import {Component, Input, OnInit, AfterContentChecked} from '@angular/core';
import {LoadStylesService} from '../../../../core/services/load-styles/load-styles.service';
import '../../../../../assets/vendor/cubeportfolio/js/jquery.cubeportfolio.min.js';
import '../../../../../assets/js/components/hs.cubeportfolio.js';

declare var $: any;

@Component({
    selector: 'app-hotel-cubes',
    templateUrl: './hotel-cubes.component.html',
    styleUrls: ['./hotel-cubes.component.css']
})
export class HotelCubesComponent implements OnInit, AfterContentChecked {

    @Input()
    showAllOption = true;

    @Input()
    showLegend = false;

    @Input()
    currentPage: string;

    path: string;
    defaultFilter: string;

    constructor(private loadStylesService: LoadStylesService) {
    }

    getRenderClass() {
        return this.showAllOption ? '' : 'd-none';
    }

    isNotMobile() {
        return document.body.clientWidth >= 415;
    }

    ngOnInit() {
      this.loadStylesService.loadStyle("cpf-bundle");
      this.defaultFilter = this.showAllOption ? '*' : '.camp';
      $.HSCore.components.HSCubeportfolio.init('#hotelCubes', {
          defaultFilter: this.defaultFilter
      });
    }

    ngAfterContentChecked() {
        const cubes = document.getElementsByClassName('cbp-item');
        const check = cubes[0] as HTMLElement;
        if (check && check.style.top !== '') {
            for (let i = 0; i < cubes.length; i++) {
                const thisCube = cubes[i] as HTMLElement;
                if (thisCube.style.top === '254px') {
                    thisCube.style.top = '222px';
                }
                if (thisCube.style.top === '32px') {
                    thisCube.style.top = '0px';
                }
                if (thisCube.style.top === '476px') {
                    thisCube.style.top = '444px';
                }
            }
        }
    }
}
